<template>
	<div class="flex">
		<TnHeading
			type="h1"
			size="l"
		>
			{{ content.heading }}
		</TnHeading>

		<TnParagraph>
			{{ content.reservationInformation }} <span class="bold">{{ order.id }}</span>
		</TnParagraph>

		<RichText
			class="paragraph-style"
			:text="content.reservationDisclaimer"
		/>

		<RichText
			class="paragraph-style"
			:text="content.ageDisclaimer"
		/>

		<TnHeading
			type="h2"
			size="s"
		>
			{{ content.reservedItemsHeading }}
		</TnHeading>
		<ECommerceClickAndCollectProductCard />

		<TnCard
			border
			class="padding-m"
		>
			<div>
				<TnHeading
					type="h3"
					size="s"
					class="margin-bottom-m"
					>{{ content.personalInformationHeading }}</TnHeading
				>
				<TnParagraph>Fornavn: {{ order.firstname }}</TnParagraph>
				<TnParagraph>Etternavn: {{ order.lastname }}</TnParagraph>
				<TnParagraph>Telefonnummer: {{ order.phone }}</TnParagraph>
				<TnParagraph>E-postadresse: {{ order.email }}</TnParagraph>
			</div>
		</TnCard>

		<TnCard
			border
			class="padding-m"
		>
			<div>
				<TnHeading
					type="h3"
					size="s"
					class="margin-bottom-m"
					>{{ content.storeHeading }}</TnHeading
				>
				<TnParagraph
					bold
					class="margin-bottom-s"
					>{{ store.name }}</TnParagraph
				>
				<TnParagraph class="margin-bottom-s">{{ storeAddress }}</TnParagraph>
				<TnParagraph
					v-for="(dayGroup, i) in openingHours"
					size="s"
					:key="i"
					>{{ `${dayGroup.name}: ${dayGroup.openingTime.opening}-${dayGroup.openingTime.closing}` }}</TnParagraph
				>
			</div>
		</TnCard>

		<TnCard
			v-if="order.message"
			border
			class="padding-m"
		>
			<div>
				<TnHeading
					type="h3"
					size="s"
					class="margin-bottom-m"
					>{{ content.messageForStoreHeading }}</TnHeading
				>
				<TnParagraph>{{ order.message }}</TnParagraph>
			</div>
		</TnCard>
	</div>
</template>

<script>
import { compressOpeningHours } from "../helpers/openingHoursHelper.js";

export default defineNuxtComponent({
	name: "ECommerceClickAndCollectOrderConfirmation",

	props: {
		content: {
			type: Object,
			required: true,
		},
		order: {
			type: Object,
			required: true,
		},
		store: {
			type: Object,
			required: true,
		},
	},

	computed: {
		openingHours() {
			return compressOpeningHours(this.store.standardOpeningTimes);
		},
		storeAddress() {
			return `${this.store.address.streetAddress}, ${this.store.address.postalCode} ${this.store.address.postalPlace}`;
		},
	},
});
</script>

<style lang="scss" scoped>
.bold {
	@include font-text-bold-m;
}

.flex {
	display: flex;
	flex-direction: column;

	&.center {
		align-items: center;
	}

	.opening-hours {
		display: flex;
		flex-direction: column;
		gap: $spacing-s;

		.opening-hour {
			width: 200px;
			display: flex;
			justify-content: space-between;
		}
	}
}

.paragraph-style {
	@include font-text-m;
}
</style>
